import { render } from "./SeatDetails.vue?vue&type=template&id=384f1581&scoped=true"
import script from "./SeatDetails.vue?vue&type=script&lang=js"
export * from "./SeatDetails.vue?vue&type=script&lang=js"

import "./SeatDetails.vue?vue&type=style&index=0&id=384f1581&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384f1581"]])

export default __exports__